import { gql } from '@apollo/client';

/**
 * 改流向可选项查询：返回本站（当前登录仓）按尾程商分组的可选流向 + 对应分拣规则。
 * 后端按 warehouseId → hubCode 过滤 common_config，无参数。
 */
export const GET_BAG_RESHIP_FLOW_OPTIONS = gql`
  query GetBagReshipFlowOptions {
    carrierWithFlowList {
      code
      flowList {
        code
        sortingRule
      }
    }
  }
`;

export interface ReshipFlowType {
  /** 流向 code（分拣规则中段，选中后作为 targetFlow 写入包牌 nextStop） */
  code: string;
  /** 完整分拣规则整串（hubCode-flow-carrier，展示用） */
  sortingRule: string;
}

export interface ReshipCarrierType {
  /** 尾程商 code（分拣规则末段） */
  code: string;
  flowList: ReshipFlowType[];
}

export interface GetBagReshipFlowOptionsResponse {
  carrierWithFlowList: ReshipCarrierType[];
}
